export const green = {
  main: 'hsla(123, 46%, 34% , 1)',
  A800: 'hsla(137, 49%, 50%, 1)',
  A700: 'hsla(145, 100%, 39%, 1)',
  '190p': 'hsla(123, 46%, 34% , 0.1)',
  '160p': 'hsla(125, 49%, 13%, 1)',
  active: 'hsla(174, 48%, 21%, 1)',
  600: 'hsla(123, 41%, 45%, 1)',
  500: 'hsla(122, 39%, 49%, 1)',
  50: 'hsla(125, 39%, 94%, 1)',
};

export type GreenPalette = typeof green;
